/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {AfterContentInit, Component, ContentChildren, Inject, QueryList} from '@angular/core';

import {IfActiveService} from '../../utils/conditional/if-active.service';
import {IfOpenService} from '../../utils/conditional/if-open.service';

import {TabLinkDirective} from './tab-link.directive';
import {TABS_ID, TABS_ID_PROVIDER} from './tabs-id.provider';
import {TabsService} from './tabs-service';
export class Tabs implements AfterContentInit {
    
    tabLinkDirectives: QueryList<TabLinkDirective>;
/**
 * @param {?} ifActiveService
 * @param {?} ifOpenService
 * @param {?} tabsService
 * @param {?} tabsId
 */
constructor(public ifActiveService: IfActiveService,
public ifOpenService: IfOpenService,
public tabsService: TabsService,
public tabsId: number) {}
/**
 * @return {?}
 */
get activeTabInOverflow() {
        return this.tabsService.overflowTabs.indexOf(this.tabsService.activeTab) > -1;
    }
/**
 * @return {?}
 */
ngAfterContentInit() {
        if (typeof this.ifActiveService.current === "undefined") {
            this.tabLinkDirectives.first.activate();
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
toggleOverflow(event: any) {
        this.ifOpenService.toggleWithEvent(event);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-tabs",
    template: `
        <ul class="nav" role="tablist">
            <!--tab links-->
            <ng-container *ngFor="let link of tabLinkDirectives">
                <ng-container *ngIf="link.tabsId === tabsId && !link.inOverflow"
                              [ngTemplateOutlet]="link.templateRefContainer.template">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="tabsService.overflowTabs.length > 0">
                <div class="tabs-overflow bottom-right" [class.open]="ifOpenService.open"
                     (click)="toggleOverflow($event)">
                    <li role="presentation" class="nav-item">
                        <button class="btn btn-link nav-link dropdown-toggle" [class.active]="activeTabInOverflow">
                            <clr-icon shape="ellipsis-horizontal" [class.is-info]="ifOpenService.open"></clr-icon>
                        </button>
                    </li>
                    <!--tab links in overflow menu-->
                    <clr-tab-overflow-content>
                        <ng-container *ngFor="let link of tabLinkDirectives">
                            <ng-container *ngIf="link.tabsId === tabsId && link.inOverflow"
                                          [ngTemplateOutlet]="link.templateRefContainer.template">
                            </ng-container>
                        </ng-container>
                    </clr-tab-overflow-content>
                </div>
            </ng-container>
        </ul>
        <!--tab content-->
        <ng-content></ng-content>
    `,
    providers: [IfActiveService, IfOpenService, TabsService, TABS_ID_PROVIDER]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: IfActiveService, },
{type: IfOpenService, },
{type: TabsService, },
{type: undefined, decorators: [{ type: Inject, args: [TABS_ID, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tabLinkDirectives': [{ type: ContentChildren, args: [TabLinkDirective, {descendants: true}, ] },],
};
}

function Tabs_tsickle_Closure_declarations() {
/** @type {?} */
Tabs.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Tabs.ctorParameters;
/** @type {?} */
Tabs.propDecorators;
/** @type {?} */
Tabs.prototype.tabLinkDirectives;
/** @type {?} */
Tabs.prototype.ifActiveService;
/** @type {?} */
Tabs.prototype.ifOpenService;
/** @type {?} */
Tabs.prototype.tabsService;
/** @type {?} */
Tabs.prototype.tabsId;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
